import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const BillingPerZonePage = lazy(() => import('./BillingPerZonePage'));

const path = 'reports/billing/per-zone';
const BillingPerZoneRoute: FuseRouteItemType = {
	path: path,
	element: <BillingPerZonePage />,
	settings: {
		layout: {
			config: {
				navbar: {
					display: true
				},
				toolbar: {
					title: 'Zone',
					showCrumbs: false,
					helpName: 'Billing Per Zone'
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	}
};

export default BillingPerZoneRoute;
